import { atom } from 'recoil';

export const DrawerState = atom({
  key: 'DrawerState',
  default: false,
});
